// extracted by mini-css-extract-plugin
module.exports = {"container":"Skotselrad_container__JN30Q","title":"Skotselrad_title__CsQ7y","sub":"Skotselrad_sub__3f_PL"};